import { createContext, useContext } from 'react';

export interface ReportPollingContextType {
	needUpdate?: boolean;
	isUpdateLoading?: boolean;
	readyForUpdate?: boolean;
	isReportLoading?: boolean;
	/** 첫 분석 polling 이 에러 또는 시간 초과로 완료 없이 종료됐는지 */
	isPollingFailed?: boolean;
}

export const ReportPollingContext = createContext<ReportPollingContextType | undefined>(
	undefined,
);

export const useReportPollingContext = () => {
	const context = useContext(ReportPollingContext);

	if (!context) {
		throw new Error(
			'useReportPollingContext must be used within a ReportPollingProvider',
		);
	}

	return context;
};

export const ReportPollingProvider = ReportPollingContext.Provider;
